import React from 'react';
import { ReactQueryClientProvider, useErrorHandling } from '@invision/core';
import { InvRouter } from '@invision/ui';
import { AuthenticationFlowProvider } from '../contexts';
import { useAuthenticationApiConfiguration } from '../utils';
import { AuthenticationRouter } from './router';
import { SessionGuard } from '../components/shared';
import { AUTHENTICATION_ROUTES } from '../constants';
import { generatePath } from 'react-router-dom';

export function App() {
  useErrorHandling();
  useAuthenticationApiConfiguration();

  return (
    <InvRouter getHomePath={() => generatePath(AUTHENTICATION_ROUTES.LOGIN)}>
      <ReactQueryClientProvider>
        <AuthenticationFlowProvider>
          <SessionGuard>
            <AuthenticationRouter />
          </SessionGuard>
        </AuthenticationFlowProvider>
      </ReactQueryClientProvider>
    </InvRouter>
  );
}
